module.exports = "<md-button class=\"md-icon-button\" ng-click=\"nav.close()\">\r\n    <md-icon class=\"material-icons\">close</md-icon>\r\n</md-button>";


/*****************
 ** WEBPACK FOOTER
 ** ./DeliveryCreate/UI/app/features/navigation/toolbar/toolbarClose.html
 ** module id = 292
 ** module chunks = 0
 **/